export default __webpack_public_path__ + "static/media/slide-1.55fb484a.png";